<template>
  <div>
    <div class="content-header">
      <h1>{{ title }}</h1>
    </div>
    <section class="content">
      <div class="box">
        <div class="box-header">
          <button class="btn btn-success btn-sm" type="button" @click="createShow()"><i class="fa fa-plus" aria-hidden="true"></i> Pridať novú položku</button>
          <code-list-modal :show-model="showCreateModal" :model="selectedItem" :module-name="moduleName" @close="createHide()"></code-list-modal>
          <div class="box-tools">
            <div class="input-group input-group-sm input-search hidden-xs">
              <input type="text" v-model="query" class="form-control pull-right" placeholder="Vyhľadaj podľa názvu.">

              <div class="input-group-btn">
                <button type="submit" class="btn btn-default"><i class="fa fa-search"></i></button>
              </div>
            </div>
          </div>
        </div>
        <div class="box-body">
          <div class="row" v-if="items.length">
            <div class="col-md-12">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th>Názov</th>
                  <th>Popis</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <template v-for="item in items">
                  <tr :class="{inactive : !item.valid}">
                    <td>{{ item.label }}</td>
                    <td>{{ item.shortDescription }}</td>
                    <td class="text-right text-nowrap">
                      <button class="btn btn-xs btn-link" @click.prevent="editItem(item)" :disabled="!item.valid"><i class="fa fa-2x fa-pencil-square-o text-primary" title="Editovať"></i></button>
                      <button class="btn btn-xs btn-link" @click.prevent="item.valid ? deactivateItem(item) : activateItem(item)"><i :class="{'fa-toggle-on': item.valid, 'fa-toggle-off text-success': !item.valid}" class="fa fa-2x" :title="item.valid ? 'Deaktivovať' : 'Aktivovať'"></i></button>
                      <button class="btn btn-xs btn-link" @click.prevent="deleteItem(item)"><i class="fa fa-2x fa-times text-danger" title="Zmazať"></i></button>
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>
            </div>
          </div>
          <loading id="codeListItems"></loading>
          <no-records :data="items" loadingId="codeListItems"></no-records>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import codeListMixin from './codeListMixin';
  import loading from 'components/loading';
  import noRecords from 'components/noRecords';

  export default {
    components: {loading, noRecords},
    mixins: [codeListMixin],
  }
</script>



// WEBPACK FOOTER //
// client/components/codeListGeneric.vue